import CircleWarningIcon from "@/assets/circle-warning-icon.svg?react"
import { I18nEnum, UserLanguageEnum } from "@/shared/lib/i18n/i18n.types"
import i18n from "@/shared/lib/react-i18next"
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@beringlab/ui"
import { Link } from "@tanstack/react-router"

const UsageWarningTooltip = () => {
  const isKoreanLanguage =
    i18n.language.startsWith(I18nEnum.Ko) ||
    i18n.language.startsWith(UserLanguageEnum.Ko)
  return (
    <TooltipProvider delayDuration={0}>
      <Tooltip>
        <TooltipTrigger>
          <CircleWarningIcon width="18" height="18" className="text-warning" />
        </TooltipTrigger>
        <TooltipContent
          className="max-w-[250px] bg-warning text-white"
          arrowClassName="bg-warning fill-warning"
        >
          {isKoreanLanguage ? (
            <>
              <p>
                단어 번역을 대부분 사용하셨습니다. 단어 부족으로 인해 불편을
                겪지 않도록{" "}
              </p>
              <Link to="/subscription" className="underline underline-offset-2">
                <p>지금 바로 플랜을 업그레이드하세요 →</p>
              </Link>
            </>
          ) : (
            <>
              <p>
                You’ve used most of your word translations. Make sure you don’t
                run out of words –
              </p>
              <Link to="/subscription" className="underline underline-offset-2">
                <p>upgrade your plan now →</p>
              </Link>
            </>
          )}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}

export default UsageWarningTooltip
